import { carouselItems } from '@/mocks/homepage';

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选当下最热电视剧专题，一站式了解追剧风向标
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <article
              key={item.id}
              className={`group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2' : ''
              } ${idx === 1 ? 'sm:col-span-2 lg:col-span-3' : ''}`}
            >
              <div className={`relative ${idx === 0 ? 'aspect-[16/10] lg:aspect-auto lg:h-full' : idx === 1 ? 'aspect-[21/9]' : 'aspect-[4/3]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/30 to-transparent"></div>

                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/85 text-white text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <p className="text-xs text-primary-400 font-medium mb-1.5">{item.subtitle}</p>
                  <h3 className="text-base md:text-lg font-bold text-foreground-950 font-heading mb-1.5 leading-snug">
                    {item.title}
                  </h3>
                  {['lg:col-span-2', 'sm:col-span-2'].some(c => (idx === 0 ? 'lg:col-span-2' : '') === c) && (
                    <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                      {item.description}
                    </p>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}